import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
  FaLeaf,
  FaHandshake,
  FaSeedling,
} from "react-icons/fa";

export default function ContactUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section className="MainBodySection">

      {/* TOP BRAND STRIP */}
      <div
        className="py-5 text-white"
        style={{
          background: "linear-gradient(120deg, #17381f 0%, #1d4d2a 60%, #256134 100%)",
        }}
      >
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-7">
              <div className="text-uppercase small text-warning font-semi-bold">Contact Us</div>
              <h2 className="font-bold mb-3">Kinemo Agro Seeds and Chemical Traders Co. Ltd</h2>
              <p className="mb-0 opacity-75" style={{ fontSize: "1.05rem" }}>
                Reach us for quality agricultural inputs, seeds, feeds, and agrochemicals.
              </p>
            </div>
            <div className="col-lg-5">
              <div className="bg-white text-dark rounded-4 p-4 shadow-sm">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaSeedling className="text-primary" size={24} />
                  <div>
                    <div className="font-bold">Reliable Inputs</div>
                    <div className="text-muted small">Seeds, agrochemicals, feeds, and chicks</div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaHandshake className="text-primary" size={22} />
                  <div>
                    <div className="font-bold">Farmer Support</div>
                    <div className="text-muted small">Training, consultation, and guidance</div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <FaLeaf className="text-primary" size={22} />
                  <div>
                    <div className="font-bold">Sustainable Growth</div>
                    <div className="text-muted small">Eco-friendly practices and innovation</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN CONTACT CONTENT */}
      <div className="bg-surface py-5">
        <div className="container">

          {/* CONTACT METHODS */}
          <div className="row g-4 mb-5">

            {/* PHONE */}
            <div className="col-md-4">
              <div className="card-blur h-100 p-4 rounded-4 shadow-sm">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaPhoneAlt size={26} className="text-primary" />
                  <h5 className="font-bold mb-0 text-primary">Telephone</h5>
                </div>
                <a href="tel:+255784587121" className="d-block text-decoration-none text-dark mb-1">
                  +255 784 587 121
                </a>
              </div>
            </div>

            {/* WHATSAPP */}
            <div className="col-md-4">
              <div className="bg-success text-white h-100 p-4 rounded-4 shadow-sm">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaWhatsapp size={28} />
                  <h5 className="font-bold mb-0">WhatsApp</h5>
                </div>
                <p className="opacity-75 mb-2">
                  Instant communication with our team
                </p>
                <a
                  href="https://wa.me/255784587121"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-light btn-sm rounded-pill px-4"
                >
                  Chat Now
                </a>
              </div>
            </div>

            {/* EMAIL */}
            <div className="col-md-4">
              <div className="card-blur h-100 p-4 rounded-4 shadow-sm">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaEnvelope size={26} className="text-primary" />
                  <h5 className="font-bold mb-0 text-primary">Email</h5>
                </div>
                <a
                  href="mailto:info@kinemoagro.com"
                  className="text-decoration-none text-dark"
                >
                  info@kinemoagro.com
                </a>
              </div>
            </div>
          </div>

          {/* OFFICE LOCATIONS */}
          <div className="row g-4">

            {/* CORPORATE OFFICE */}
            <div className="col-md-6">
              <div className="card-blur p-4 rounded-4 shadow-sm h-100">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaMapMarkerAlt size={26} className="text-secondary" />
                  <h5 className="font-bold mb-0 text-secondary">Corporate Office</h5>
                </div>
                <p className="mb-0 text-muted" style={{ lineHeight: 1.8 }}>
                  Nzovwe Tanzam Highway<br />
                  Block No. 779 near CF Fuel Station<br />
                  Mbeya, Tanzania
                </p>
              </div>
            </div>

            {/* FACTORY */}
            <div className="col-md-6">
              <div className="card-blur p-4 rounded-4 shadow-sm h-100">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <FaMapMarkerAlt size={26} className="text-secondary" />
                  <h5 className="font-bold mb-0 text-secondary">Factory</h5>
                </div>
                <p className="mb-0 text-muted" style={{ lineHeight: 1.8 }}>
                  Ikumbi Villages close to Songwe Airport<br />
                  Mbeya, Tanzania
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
